/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateSdpUser = /* GraphQL */ `
  subscription OnCreateSdpUser($filter: ModelSubscriptionSdpUserFilterInput) {
    onCreateSdpUser(filter: $filter) {
      id
      Name
      Email
      Role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSdpUser = /* GraphQL */ `
  subscription OnUpdateSdpUser($filter: ModelSubscriptionSdpUserFilterInput) {
    onUpdateSdpUser(filter: $filter) {
      id
      Name
      Email
      Role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSdpUser = /* GraphQL */ `
  subscription OnDeleteSdpUser($filter: ModelSubscriptionSdpUserFilterInput) {
    onDeleteSdpUser(filter: $filter) {
      id
      Name
      Email
      Role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateSdpRecipe = /* GraphQL */ `
  subscription OnCreateSdpRecipe(
    $filter: ModelSubscriptionSdpRecipeFilterInput
  ) {
    onCreateSdpRecipe(filter: $filter) {
      id
      Name
      Recipe
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSdpRecipe = /* GraphQL */ `
  subscription OnUpdateSdpRecipe(
    $filter: ModelSubscriptionSdpRecipeFilterInput
  ) {
    onUpdateSdpRecipe(filter: $filter) {
      id
      Name
      Recipe
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSdpRecipe = /* GraphQL */ `
  subscription OnDeleteSdpRecipe(
    $filter: ModelSubscriptionSdpRecipeFilterInput
  ) {
    onDeleteSdpRecipe(filter: $filter) {
      id
      Name
      Recipe
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateSdpRecipeInput = /* GraphQL */ `
  subscription OnCreateSdpRecipeInput(
    $filter: ModelSubscriptionSdpRecipeInputFilterInput
  ) {
    onCreateSdpRecipeInput(filter: $filter) {
      id
      ModelNumber
      Input
      State
      Version
      ReasonForChange
      ExpiryDays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSdpRecipeInput = /* GraphQL */ `
  subscription OnUpdateSdpRecipeInput(
    $filter: ModelSubscriptionSdpRecipeInputFilterInput
  ) {
    onUpdateSdpRecipeInput(filter: $filter) {
      id
      ModelNumber
      Input
      State
      Version
      ReasonForChange
      ExpiryDays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSdpRecipeInput = /* GraphQL */ `
  subscription OnDeleteSdpRecipeInput(
    $filter: ModelSubscriptionSdpRecipeInputFilterInput
  ) {
    onDeleteSdpRecipeInput(filter: $filter) {
      id
      ModelNumber
      Input
      State
      Version
      ReasonForChange
      ExpiryDays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateProduct = /* GraphQL */ `
  subscription OnCreateProduct($filter: ModelSubscriptionProductFilterInput) {
    onCreateProduct(filter: $filter) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      CloneFromProductId
      AMSAck
      CoolCloudDBAck
      ShareddataVersion
      SoftwareVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateProduct = /* GraphQL */ `
  subscription OnUpdateProduct($filter: ModelSubscriptionProductFilterInput) {
    onUpdateProduct(filter: $filter) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      CloneFromProductId
      AMSAck
      CoolCloudDBAck
      ShareddataVersion
      SoftwareVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteProduct = /* GraphQL */ `
  subscription OnDeleteProduct($filter: ModelSubscriptionProductFilterInput) {
    onDeleteProduct(filter: $filter) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      CloneFromProductId
      AMSAck
      CoolCloudDBAck
      ShareddataVersion
      SoftwareVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateLookupOption = /* GraphQL */ `
  subscription OnCreateLookupOption(
    $filter: ModelSubscriptionLookupOptionFilterInput
  ) {
    onCreateLookupOption(filter: $filter) {
      id
      Name
      Options
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateLookupOption = /* GraphQL */ `
  subscription OnUpdateLookupOption(
    $filter: ModelSubscriptionLookupOptionFilterInput
  ) {
    onUpdateLookupOption(filter: $filter) {
      id
      Name
      Options
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteLookupOption = /* GraphQL */ `
  subscription OnDeleteLookupOption(
    $filter: ModelSubscriptionLookupOptionFilterInput
  ) {
    onDeleteLookupOption(filter: $filter) {
      id
      Name
      Options
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateActionItems = /* GraphQL */ `
  subscription OnCreateActionItems(
    $filter: ModelSubscriptionActionItemsFilterInput
  ) {
    onCreateActionItems(filter: $filter) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      ReviewerEmail
      ReviewerEmails
      CreatedByEmail
      CreationDate
      LastUpdate
      Status
      ProductId
      Input
      Version
      ReasonForChange
      CloneFromProductId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateActionItems = /* GraphQL */ `
  subscription OnUpdateActionItems(
    $filter: ModelSubscriptionActionItemsFilterInput
  ) {
    onUpdateActionItems(filter: $filter) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      ReviewerEmail
      ReviewerEmails
      CreatedByEmail
      CreationDate
      LastUpdate
      Status
      ProductId
      Input
      Version
      ReasonForChange
      CloneFromProductId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteActionItems = /* GraphQL */ `
  subscription OnDeleteActionItems(
    $filter: ModelSubscriptionActionItemsFilterInput
  ) {
    onDeleteActionItems(filter: $filter) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      ReviewerEmail
      ReviewerEmails
      CreatedByEmail
      CreationDate
      LastUpdate
      Status
      ProductId
      Input
      Version
      ReasonForChange
      CloneFromProductId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateComment = /* GraphQL */ `
  subscription OnCreateComment($filter: ModelSubscriptionCommentFilterInput) {
    onCreateComment(filter: $filter) {
      commentId
      name
      date
      text
      parent_comment_id
      property_name
      actionId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateComment = /* GraphQL */ `
  subscription OnUpdateComment($filter: ModelSubscriptionCommentFilterInput) {
    onUpdateComment(filter: $filter) {
      commentId
      name
      date
      text
      parent_comment_id
      property_name
      actionId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteComment = /* GraphQL */ `
  subscription OnDeleteComment($filter: ModelSubscriptionCommentFilterInput) {
    onDeleteComment(filter: $filter) {
      commentId
      name
      date
      text
      parent_comment_id
      property_name
      actionId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateSdpCoolCloudData = /* GraphQL */ `
  subscription OnCreateSdpCoolCloudData(
    $filter: ModelSubscriptionSdpCoolCloudDataFilterInput
  ) {
    onCreateSdpCoolCloudData(filter: $filter) {
      id
      control_id
      createdAt
      createdTime
      deleted
      display_value
      first_part
      last_part
      middle_part
      model_number
      second_part
      shareddata_version
      software_version
      updatedAt
      updatedTime
      _lastChangedAt
      _version
      __typename
      __typename
    }
  }
`;
export const onUpdateSdpCoolCloudData = /* GraphQL */ `
  subscription OnUpdateSdpCoolCloudData(
    $filter: ModelSubscriptionSdpCoolCloudDataFilterInput
  ) {
    onUpdateSdpCoolCloudData(filter: $filter) {
      id
      control_id
      createdAt
      createdTime
      deleted
      display_value
      first_part
      last_part
      middle_part
      model_number
      second_part
      shareddata_version
      software_version
      updatedAt
      updatedTime
      _lastChangedAt
      _version
      __typename
      __typename
    }
  }
`;
export const onDeleteSdpCoolCloudData = /* GraphQL */ `
  subscription OnDeleteSdpCoolCloudData(
    $filter: ModelSubscriptionSdpCoolCloudDataFilterInput
  ) {
    onDeleteSdpCoolCloudData(filter: $filter) {
      id
      control_id
      createdAt
      createdTime
      deleted
      display_value
      first_part
      last_part
      middle_part
      model_number
      second_part
      shareddata_version
      software_version
      updatedAt
      updatedTime
      _lastChangedAt
      _version
      __typename
      __typename
    }
  }
`;
export const onCreateSdpAmsData = /* GraphQL */ `
  subscription OnCreateSdpAmsData(
    $filter: ModelSubscriptionSdpAmsDataFilterInput
  ) {
    onCreateSdpAmsData(filter: $filter) {
      id
      RecipeName
      Type
      ModelNum
      Revision
      params
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSdpAmsData = /* GraphQL */ `
  subscription OnUpdateSdpAmsData(
    $filter: ModelSubscriptionSdpAmsDataFilterInput
  ) {
    onUpdateSdpAmsData(filter: $filter) {
      id
      RecipeName
      Type
      ModelNum
      Revision
      params
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSdpAmsData = /* GraphQL */ `
  subscription OnDeleteSdpAmsData(
    $filter: ModelSubscriptionSdpAmsDataFilterInput
  ) {
    onDeleteSdpAmsData(filter: $filter) {
      id
      RecipeName
      Type
      ModelNum
      Revision
      params
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateSdpAutoDeleteSchedule = /* GraphQL */ `
  subscription OnCreateSdpAutoDeleteSchedule(
    $filter: ModelSubscriptionSdpAutoDeleteScheduleFilterInput
  ) {
    onCreateSdpAutoDeleteSchedule(filter: $filter) {
      id
      temp_model_number
      actual_model_number
      expiry_days
      expiry_date
      created_by
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSdpAutoDeleteSchedule = /* GraphQL */ `
  subscription OnUpdateSdpAutoDeleteSchedule(
    $filter: ModelSubscriptionSdpAutoDeleteScheduleFilterInput
  ) {
    onUpdateSdpAutoDeleteSchedule(filter: $filter) {
      id
      temp_model_number
      actual_model_number
      expiry_days
      expiry_date
      created_by
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSdpAutoDeleteSchedule = /* GraphQL */ `
  subscription OnDeleteSdpAutoDeleteSchedule(
    $filter: ModelSubscriptionSdpAutoDeleteScheduleFilterInput
  ) {
    onDeleteSdpAutoDeleteSchedule(filter: $filter) {
      id
      temp_model_number
      actual_model_number
      expiry_days
      expiry_date
      created_by
      createdAt
      updatedAt
      __typename
    }
  }
`;
